import { useState, useEffect, useCallback } from 'react'
import { supabase } from '../lib/supabase'

// HQ email broadcasts: history (superadmin RLS) + send via the send-broadcast
// edge function, which computes the segment's recipients server-side.
export function useBroadcasts(currentUser) {
  const [history, setHistory] = useState([])

  const fetchHistory = useCallback(async () => {
    const { data } = await supabase
      .from('email_broadcasts').select('*')
      .order('created_at', { ascending: false }).limit(20)
    setHistory((data || []).map((r) => ({
      id: r.id,
      segment: r.segment,
      subject: r.subject,
      body: r.body,
      recipientCount: r.recipient_count,
      failedCount: r.failed_count,
      createdAt: r.created_at ? new Date(r.created_at) : null,
    })))
  }, [])

  useEffect(() => {
    if (currentUser?.role === 'superadmin') fetchHistory()
  }, [currentUser?.id, fetchHistory])

  async function sendBroadcast({ segment, subject, body, testTo }) {
    const { data, error } = await supabase.functions.invoke('send-broadcast', {
      body: { segment, subject, body, testTo },
    })
    if (error) {
      let msg = 'Broadcast failed. Please try again.'
      try {
        const errBody = await error.context.json()
        if (errBody?.error) msg = errBody.error
      } catch { /* keep default */ }
      return { success: false, message: msg }
    }
    if (!testTo) await fetchHistory()
    return { success: true, ...data }
  }

  return { history, sendBroadcast, fetchHistory }
}

// Paystack webhook event log (superadmin RLS) for the Billing feed.
export function usePaystackEvents(currentUser) {
  const [events, setEvents] = useState([])

  const fetchEvents = useCallback(async () => {
    const { data } = await supabase
      .from('paystack_events').select('id, event_type, organization_id, customer_email, amount, created_at')
      .order('created_at', { ascending: false }).limit(20)
    setEvents((data || []).map((r) => ({
      id: r.id,
      eventType: r.event_type,
      organizationId: r.organization_id,
      customerEmail: r.customer_email,
      amount: r.amount != null ? Number(r.amount) : null,
      createdAt: r.created_at ? new Date(r.created_at) : null,
    })))
  }, [])

  useEffect(() => {
    if (currentUser?.role === 'superadmin') fetchEvents()
  }, [currentUser?.id, fetchEvents])

  return { events, fetchEvents }
}
